import { Predicates } from "../libraries/predicates/predicates";

type LabelFormatType<T> = {
  keys: (keyof T)[];
  separator?: string;
  prefix?: string;
  suffix?: string;
};

const buildLabel = <T>(item: T, format: LabelFormatType<T>): string => {
  const { keys, separator = " - ", prefix = "", suffix = "" } = format;
  const parts = keys.map((key) => String(item[key]));
  return `${prefix}${parts.join(separator)}${suffix}`;
};

export const formatIntoOption = <T extends { name: string }>(
  item: T,
  labelFormat?: LabelFormatType<T>
): { value: T; label: string } | null => {
  if (!Predicates.isNotNullAndNotUndefined(item)) {
    return null;
  }

  const label =
    labelFormat && labelFormat.keys.length > 0
      ? buildLabel(item, labelFormat)
      : item.name;

  return { value: item, label };
};